var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',{staticClass:"slide_wrapper_item"},[_c('span'),_c('div',{staticClass:"slide_wrapper_item_cap"},[_c('span',{staticClass:"reds"},[_vm._v("Плохо")]),_c('span',{staticClass:"greens"},[_vm._v("Хорошо")])])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }